<template>
  <custom-callout :border-color="borderColor">
    <div class="row">
      <div class="col-3 col-lg-2 border-right">
        <div
          class="d-flex flex-column align-items-center justify-content-center"
        >
          <span
            v-if="isActive"
            class="badge badges badge-active"
            v-text="'Activo'"
          />
          <span
            v-else
            class="badge badges badge-inactive"
            v-text="'Inactivo'"
          />
        </div>
      </div>

      <div class="col-5 col-lg-4">
        <div class="legend">Nombre del Proveedor:</div>
        <div class="font-weight-normal text-black" v-text="data.name" />
      </div>

      <div class="col-4 col-lg-3">
        <div class="legend">Tipo de Proveedor:</div>
        <div class="font-weight-normal text-black" v-text="data.typeName" />
      </div>

      <div class="col-12 col-lg-3 d-flex justify-content-end">
        <action-button
          class="mx-4 px-4"
          i="fas fa-file-import"
          text="Entrar"
          variant="outline-success"
          @click="
            $router.push({
              name: 'provider-edit',
              params: {
                companyId: data.companyId,
                editMode: false,
                fiscalYearId: data.fiscalYearId,
              },
            })
          "
        />
      </div>
    </div>
  </custom-callout>
</template>

<script>
import ActionButton from '@/components/common/ActionButton';
import CustomCallout from '@/components/common/CustomCallout';

export default {
  name: 'ProviderSearchResultItem',
  components: {
    ActionButton,
    CustomCallout,
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        id: null,
        status: '',
        name: '',
        typeName: '',
        ssn: '',
      }),
      required: true,
    },
  },
  computed: {
    isActive() {
      return this.data.status === '1';
    },
    borderColor() {
      return this.isActive ? 'green' : '#b5c3bc';
    },
  },
};
</script>

<style lang="scss" scoped>
.badges {
  color: black;
  font-size: 16px;
  width: 144px;
  height: 32px;
  line-height: 13px;
  border-radius: 20px;
  padding: 10px;
}

.badge-active {
  background: #a3e5b3;
}

.badge-inactive {
  background: #b5c3bc;
}

.border-right {
  border-right: #b5c3bc 1px solid;
}

.col-separator {
  border-right: 1px solid #e9ecef;
}

.legend {
  font-size: 11px;
  font-weight: 400;
}

.text-black {
  color: #11291b;
}
</style>
